import React from 'react'
import { COLORS } from '../../../constants'
import PnlPrice from '../../PositionColumns/PnlPrice'
import TranslateText from '../../TranslateText'
import { Button, Col, Input, Popover, Row, Tag, Tooltip, message } from 'antd'
import { Text, View } from '../../../../styles/reactnative'
import { from } from 'rxjs'
import EntryTime from '../../PositionColumns/EntryTime'
import KrwPrice from '../../PositionColumns/KrwPrice'
import API from '../../../../utils/api'
import MemoInput from '../MemoInput'

export const column_wallet = (mutate, show, token) => {
	return [
		{
			title: '시간',
			dataIndex: 'sent_at',
			key: 'sent_at',
			align: 'center',
			width: 115,
			render: (text, record) => (
				<EntryTime time={text} relative={true} relativeAdd={true} />
			),
		},
		{
			title: '내역',
			dataIndex: 'detail',
			width: 90,
			align: 'center',
			key: 'detail',
			render: (text, record) => <TranslateText text={text} />,
		},
		{
			title: '수량',
			dataIndex: 'amountsymbol',
			align: 'center',
			key: 'amountsymbol',
			render: (text, record) => (
				<PnlPrice
					dp={0}
					price={record?.amount}
					ep_id={record?.exchange_pairs_id}
					krw={record?.symbol == 'KRW' ? true : false}
				/>
			),
		},
		{
			title: '마지막잔액',
			dataIndex: 'afteramount',
			align: 'center',
			key: 'afteramount',
			render: (text, record) => <KrwPrice price={record?.afteramount} />,
		},
		{
			title: '별도입출사유',
			dataIndex: 'adminmemo',
			align: 'center',
			key: 'adminmemo',
			render: (text, record) => {
				if (record?.detail?.includes('ADMIN')) {
					return <MemoInput data={record} mutate={mutate} />
				} else {
					return <Text>{text}</Text>
				}
			},
		},
		{
			title: '출금락',
			dataIndex: 'lockcount',
			align: 'center',
			key: 'lockcount',
			width: 80,
			render: (text, record) => (
				<>
					{text ? (
						<>
							<Text>{text ? text + '회' : ''}</Text>
							<Popover
								content={
									<>
										<Input
											size="small"
											onChange={e => {
												record.lockcount =
													e.target.value
											}}
										/>
										<Button
											size="small"
											onClick={() => {
												API.put(
													'/admin/lockcount',
													token + '',
													{
														id: record?.id,
														lockcount:
															record?.lockcount,
													}
												).then(res => {
													mutate()
													message.success(
														'롤링횟수 변경'
													)
												})
											}}>
											변경
										</Button>
									</>
								}>
								<Button size="small">변경</Button>
							</Popover>
							<Button
								size="small"
								onClick={() => {
									API.delete('/admin/lockcount', token + '', {
										id: record?.id,
									}).then(res => {
										mutate()
										message.success('출금락 해제')
									})
								}}>
								제거
							</Button>
						</>
					) : (
						<Text>-</Text>
					)}
				</>
			),
		},
	]
}
